export const filter = {
    id: "",
    name: "",
    price: "",
    search: "",
    created_at: "",
    updated_at: "",
};
